<template>
  <div>
    <b-modal
      v-if="showSelectPatientModal"
      v-model="showSelectPatientModal"
      title="New Episode of care"
      header-bg-variant="primary"
      header-text-variant="white"
      size="md"
      no-close-on-backdrop
      hide-footer
      centered
      header-class="bg-purple"
    >
      <div
        class="d-flex flex-column align-items-start justify-content-between mb-4"
      >
        <b-form-group
          v-if="!selectedLocation"
          label="Location"
          class="w-100 mr-4"
        >
          <template v-slot:label>
            Location
          </template>
          <v-select
            :clearable="false"
            class="w-100"
            v-model="form.location"
            :options="locationOptions"
          ></v-select>
        </b-form-group>
        <b-form-group label="Previously admitted patient" class="w-100 mr-4">
          <v-select
            class="w-100"
            :class="
              patientOptions.length == 0 ? 'patient-picker-hide-options' : ''
            "
            v-model="form.patient"
            :options="patientOptions"
            @search="fetchPatientOptions"
            :filterable="false"
            placeholder="Search for patients"
          >
            <template #no-options="{ search }">
              {{
                search && search.length > 3 && !patientSearchChanged
                  ? "Sorry, no matching options"
                  : ""
              }}
            </template>
            <template #open-indicator>
              <span></span>
            </template>
          </v-select>
        </b-form-group>
        <div class="d-flex justify-content-center mx-auto">
          <b-button @click="selectPatient" variant="primary" class="mb-3">
            Next
          </b-button>
        </div>
      </div>
      <div class="border-bottom border-dark-gray separator-or"></div>
      <div class="d-flex justify-content-center mb-4">
        <span class="bg-white px-2">OR</span>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          @click="newPatient"
          variant="primary"
          :disabled="form.patient ? true : false"
        >
          Create new patient
        </b-button>
      </div>
    </b-modal>
    <eoc-add-edit-modal
      v-if="showEocAddEditModal"
      v-model="showEocAddEditModal"
      @onModify="onAddEditEoc"
      :locationId="form.location?.value || selectedLocation"
      :clientId="selectedPatient"
      :eligibilityVerificationId="eligibilityVerificationId"
    />
  </div>
</template>

<script>
import EocAddEditModal from "./EocAddEditModal";
import patientServer from "../../server/patient";
import { mapState } from "vuex";

export default {
  name: "CreateEocFromPatientModal",
  components: { EocAddEditModal },
  props: ["eligibilityVerificationId"],
  data() {
    return {
      form: {
        patient: null,
        location: null
      },
      patientOptions: [],
      patientSearchChanged: false,
      showSelectPatientModal: false,
      showEocAddEditModal: false
    };
  },
  methods: {
    async fetchPatientOptions(search, loading) {
      this.patientSearchChanged = true;
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      this.lastTimeout = setTimeout(async () => {
        loading(true);
        if (search.trim().length >= 3) {
          const optionsResult = await patientServer.query(
            {
              locationId: this.form.location?.value,
              searchPhrase: search
            },
            {
              "Hide-Loading": true
            }
          );
          this.patientOptions = optionsResult.map(patient => ({
            value: patient.id,
            label: this.formatClient(
              patient.firstName,
              patient.middleName,
              patient.preferredName,
              patient.lastName,
              patient.mrn
            )
          }));
          this.patientSearchChanged = false;
        } else {
          this.patientSearchChanged = false;
          this.patientOptions = [];
        }
        loading(false);
      }, 1000);
    },
    show() {
      this.showSelectPatientModal = true;
    },
    selectPatient() {
      this.showEocAddEditModal = true;
    },
    newPatient() {
      this.form.patient = null;
      if (!this.form.location) {
        this.form.location = this.selectedLocation
          ? this.locationOptions?.find(l => l.value == this.selectedLocation)
          : this.locationOptions?.length > 0
          ? this.locationOptions[0]
          : null;
      }
      this.showEocAddEditModal = true;
    },
    onAddEditEoc() {
      this.showSelectPatientModal = false;
      this.showEocAddEditModal = false;
      this.form.patient = null;
      this.$emit("onAddEditEoc");
    }
  },
  computed: {
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      currentUser: state => state.currentUser
    }),
    ...mapState("client", {
      locations: state =>
        state.locations.map(location => ({
          value: location.id,
          label: location.name
        }))
    }),
    locationOptions() {
      if (this.currentUser && this.currentUser.role.name == "Tech Staff") {
        return this.locations;
      } else {
        return this.locations.filter(loc =>
          this.currentUser.accessToLocations.some(
            access => access.id === loc.value
          )
        );
      }
    },
    selectedPatient() {
      return this.form.patient ? this.form.patient.value : null;
    }
  }
};
</script>

<style scoped>
.separator-or {
  margin-bottom: -13px;
}
</style>
